import React from 'react';
import { FormControl, TextField } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import cx from 'classnames';
import { Autocomplete } from '@material-ui/lab';
import {
  AutocompleteChangeReason,
  AutocompleteInputChangeReason,
} from '@material-ui/lab/useAutocomplete/useAutocomplete';
import { AutocompleteRenderOptionState } from '@material-ui/lab/Autocomplete/Autocomplete';

type Option<Value> = {
  value: Value;
  text: string;
};

export interface AutocompleteInputProps<Value> {
  options: Option<Value>[];
  label: string;
  name?: string;
  value?: Value;
  onChange?: (e: any, option?: any, reason?: AutocompleteChangeReason) => void;
  onInputChange?: (e: any, option?: any, reason?: AutocompleteInputChangeReason) => void;
  className?: string;
  required?: boolean;
  errorMessage?: string;
  disableHelperText?: boolean;
  renderOption?: (option: any, state: AutocompleteRenderOptionState) => React.ReactNode;
  [x: string]: any;
}

function AutocompleteInput<Value>(props: AutocompleteInputProps<Value>) {
  const {
    options,
    label,
    value,
    onChange,
    className = '',
    required,
    disableHelperText,
    errorMessage,
    onInputChange,
    renderOption,
    ...rest
  } = props;

  const classes = useStyles();

  return (
    <FormControl className={cx({ [className]: className })}>
      <Autocomplete
        options={options || []}
        freeSolo
        autoSelect
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant='filled'
            margin='dense'
            required={!!required}
            helperText={!disableHelperText && (errorMessage || '\u00A0')}
            error={(errorMessage || '').length > 0}
            className={classes.TextField}
            fullWidth
            {...rest}
          />
        )}
        // Only ever pass a real matched option (or null) here - falling back to
        // the raw, unmatched value (e.g. text still being typed) makes MUI treat
        // the in-progress input as an already-selected value, which collapses
        // its filter to match everything instead of narrowing by what's typed.
        value={(options || []).find((o) => o.value === value) ?? (null as any)}
        getOptionLabel={(o) => (o as any)?.text || o}
        renderOption={renderOption}
        onChange={(e, value, reason) => {
          const actualValue = (value as any)?.value || value;
          onChange && onChange(e, actualValue, reason);
        }}
        onInputChange={(e, value, reason) => {
          const actualValue = (value as any)?.value || value;
          onInputChange && onInputChange(e, actualValue, reason);
        }}
      />
    </FormControl>
  );
}

const useStyles = makeStyles(() => ({
  TextField: {},
  MenuPaper: {},
}));

export default AutocompleteInput;
